// extracted by mini-css-extract-plugin
export default {"flexColumn":"main-page_flexColumn__42i1G","tabWidth":"main-page_tabWidth__prJYi","app":"main-page_app__Q-xRS"};